<template>
  <div class="dialogBox">
    <el-row type="flex" class="dialogTitle" justify="left">
      <el-col :span="3">
        <p><span style="color:red;">*</span>角色名称:</p>
      </el-col>
      <el-col :offset="1" :span="10">
        <el-input v-model="roleName" placeholder="请输入角色名称"></el-input>
      </el-col>
    </el-row>
    <div>
      <el-tabs type="border-card">
        <el-tab-pane
          v-for="item in treeList"
          :key="item.menuId"
          :label="item.menuName"
        >
          <el-row
            class="roleOperatTable roleOperatTableHear"
            type="flex"
            justify="left"
          >
            <el-col :span="6">
              <div>
                <el-checkbox v-model="item.isCheck">功能模块</el-checkbox>
              </div>
            </el-col>
            <el-col :span="10">
              操作按钮
            </el-col>
          </el-row>
          <el-row
            class="roleOperatTable"
            v-for="tree in item.children"
            :key="tree.menuId"
            type="flex"
            justify="left"
          >
            <el-col :span="6">
              <div>
                <el-checkbox v-model="tree.isCheck">
                  {{ tree.menuName }}</el-checkbox
                >
              </div>
            </el-col>
            <el-col :span="10">
              <div>
                <el-checkbox
                  v-if="tree.children"
                  v-for="operatBut in tree.children"
                  v-model="operatBut.isCheck"
                  :key="operatBut.menuId"
                  >{{ operatBut.menuName }}</el-checkbox
                >
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-row v-if="operatType!=3" type="flex" class="dailogButBox" justify="center">
      <el-col :span="7">
        <el-button size="medium" @click="$emit('reload')">取消</el-button>
      </el-col>
      <el-col :span="4">
        <el-button size="medium" type="primary" @click="submit">确认</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: ["rowInfo", "operatType"],
  data() {
    return {
      treeCheck: [],
      treeList: [],
      roleName: "",
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      let checkList = [];
      if (this.operatType == 2||this.operatType == 3) {
        await this.$axios.get("/role/" + this.rowInfo.id).then((res) => {
          let { menuIds, roleName } = res.data.data;
          checkList = menuIds;
          this.roleName = roleName;
        });
      }
      await this.$axios.get("/menu/tree/list").then((res) => {
        let data = res.data.data;
        this.treeList = data.map((tree1) => {
          if (checkList.indexOf(tree1.menuId) != -1) {
            tree1.isCheck = true;
          } else {
            tree1.isCheck = false;
          }
          tree1.children.map((tree2) => {
            if (checkList.indexOf(tree2.menuId) != -1) {
              tree2.isCheck = true;
            } else {
              tree2.isCheck = false;
            }
            if (tree2.children) {
              tree2.children.map((tree3) => {
                if (checkList.indexOf(tree3.menuId) != -1) {
                  tree3.isCheck = true;
                } else {
                  tree3.isCheck = false;
                }
                return tree3;
              });
            }
            return tree2;
          });
          return tree1;
        });
      });
    },
    submit() {
      this.treeCheck = [];
      if (this.roleName == "") {
        this.$message({ type: "warning", message: "角色名称不可为空！" ,duration:1000});
        return;
      }
      this.treeList.map((tree1) => {
        if (tree1.isCheck) {
          this.treeCheck.push(tree1.menuId);
        }
        tree1.children.map((tree2) => {
          if (tree2.isCheck) {
            this.treeCheck.push(tree2.menuId);
          }
          if (tree2.children) {
            tree2.children.map((tree3) => {
              if (tree3.isCheck) {
                this.treeCheck.push(tree3.menuId);
              }
              return tree3;
            });
          }
          return tree2;
        });
        return tree1;
      });
      let subType = this.operatType == 1 ? "post" : "put";
      this.$axios({
        method: subType,
        url: "/role",
        data: { menuIds: this.treeCheck, roleName: this.roleName, id:this.rowInfo.id},
      }).then((res) => {
        this.$message({ type: "success", message: '保存成功!' ,duration:1000});
        this.$emit("reload");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialogBox {
  padding: 10px;
  .dialogTitle {
    margin-bottom: 10px;
    p {
      line-height: 260%;
      text-align: right;
    }
  }
  .el-input__inner {
    height: 34px;
  }
  .roleOperatTable {
    line-height: 200%;
    padding: 5px 10px;
    border-bottom: 1px solid #f2f2f2;
  }
  .roleOperatTableHear {
    background-color: #f2f2f2;
  }
}
</style>
